import {
  type I18nTranslation,
  useTranslation as _useTranslation,
} from '@crehana/i18n';

import { DASHBOARDS_LEARNING_PAGE_KEY } from './constants';
import { en } from './en';
import { es } from './es';
import { pt } from './pt';
import type { TKeys } from './types';

const locales: I18nTranslation = { en, pt, es };

export const useAddI18nLocales = () => {
  const { addResourceBundle } = useTranslation();

  addResourceBundle(locales);
};

export const useTranslation = () =>
  _useTranslation<TKeys>(DASHBOARDS_LEARNING_PAGE_KEY);
